<ng-container [formGroup]="group">
  @if (group.get(config.name); as field) {
    <mat-form-field
      [appearance]="'fill'"
      [color]="'accent'"
      [class.has--label]="!!config.label"
      [class.has--sub-label]="!!config.subLabel"
      [ngClass]="iconClass"
      >
      <mat-label [innerHTML]="config.label"></mat-label>
      @if (config.subLabel) {
        <div class="mat-form-field-subLabel" [innerHTML]="config.subLabel"></div>
      }
      @if (config.fieldType !== 'textarea') {
        <input
          matInput
          [formControlName]="config.name"
          [placeholder]="config.placeholder || ''"
          [autocomplete]="config.autocomplete || ''"
          [type]="config.inputType || ''"
          />
      }
      @if (config.fieldType === 'textarea') {
        <textarea
          matInput
          [formControlName]="config.name"
          [rows]="config['rows'] ? config['rows'] : '5'"
          [autocomplete]="config.autocomplete || ''"
          [placeholder]="config.placeholder || ''"
        ></textarea>
      }
      @if (config.matPrefix) {
        <mat-icon matPrefix>{{ config.matPrefix }}</mat-icon>
      }
      @if (config.matSuffix) {
        <mat-icon matSuffix>{{ config.matSuffix }}</mat-icon>
      }
      <!-- loading and validated -->
      @if (config['showStates']) {
        <div matSuffix>
          @if (field?.pending && field?.dirty) {
            <span class="icon-loader css-icon" title="loading..."></span>
          }
          @if (!field?.pending && field?.valid && field?.value) {
            <span>
              <mat-icon class="text-success">check_circle</mat-icon>
            </span>
          }
          @if (!field?.pending && field?.invalid && field?.value) {
            <span>
              <mat-icon class="text-danger">error</mat-icon>
            </span>
          }
        </div>
      }
      @if (config.hint) {
        <mat-hint align="start">{{ config.hint }}</mat-hint>
      }
      @if (field?.invalid) {
        <mat-error>{{ field | formError: config['customValidationMessages'] }}</mat-error>
      }
    </mat-form-field>
  }
</ng-container>
